// Add to card dialog button
// Add  showCartNotification 20250601
// Add thumbnail select 20250601
// Fix addEventListener 20250615 use shop-enhancer-core.js
// Fix Error Silder => <a> , redirect
//Fix collection custom 20250629
//Add edit cart 20250709
/*------
// ✅ Wait for the DOM to fully load before initializing event listeners
document.addEventListener("DOMContentLoaded", () => {
  // Loop through all quick-add buttons
  document.querySelectorAll(".add-to-cart_new").forEach((button) => {
    button.addEventListener("click", (event) => {
      const handle = event.currentTarget.dataset.handle;
      if (!handle) return;

      // Fetch the quick-add product modal HTML
      fetch(`/products/${handle}?view=quick-add`)
        .then((res) => res.text())
        .then((html) => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, "text/html");
          const modalContent = doc.querySelector(".quick-add-modal");

          if (modalContent) {
            // Remove any existing modals
            document.querySelectorAll(".quick-add-modal").forEach((el) => el.remove());
            document.body.appendChild(modalContent);

            // Re-initialize JS functionality within the modal
            initializeQuickAddModal(modalContent);

            const modal = modalContent.querySelector('[role="dialog"]');
            if (modal) modal.focus();
            modalContent.classList.add("quick-add-modal--open");

            // Close modal when clicking outside
            modalContent.addEventListener("click", (e) => {
              if (e.target === modalContent) modalContent.remove();
            });
            //Close modal wiht X
            modalContent.querySelector(".quick-add-modal__close")?.addEventListener("click", () => {
             modalContent.remove();
            });
             //keyboard
             modalContent.setAttribute("tabindex", "-1");
             modalContent.focus();

            // Handle AJAX Add to Cart
            const form = modalContent.querySelector("form");
            if (form) {
              form.addEventListener("submit", (e) => {
                e.preventDefault();

                const formData = new FormData(form);
                const variantId = formData.get("id");

                fetch("/cart/add.js", {
                  method: "POST",
                  headers: {
                    "Content-Type": "application/json",
                    Accept: "application/json",
                  },
                  body: JSON.stringify({
                    id: variantId,
                    quantity: 1,
                  }),
                })
                  .then((res) => res.json())
                  .then((data) => {
                    console.log("Added to cart:", data);

                    // Close modal after adding to cart
                    modalContent.remove();

                    // Show notification
                    showCartNotification(data);

                    // Update cart count bubble
                    updateCartCount();
                  })
                  .catch((err) => {
                    console.error("Add to cart failed:", err);
                  });
              });
            }
          }
        });
    });
  });
});
------*/ //code old dom

// ========== FILE: quick_add_custom.js ==========
// ✅ Modified: Use shared updateCartCount from core.js
window.shopEnhancer = window.shopEnhancer || {};

window.shopEnhancer.initQuickAddIcons = function (container = document) {
  const buttons = container.querySelectorAll(".add-to-cart_new");
  if (!buttons.length) return;

  buttons.forEach((button) => {
    if (button.dataset.bound === "true") return;
    button.dataset.bound = "true";

    button.addEventListener("click", (event) => {
      const currentTarget = event.currentTarget; //keep reference before fetch
      const handle = event.currentTarget.dataset.handle;
      if (!handle) return;
      const editLine = event.currentTarget.dataset.editLine;
      const variantId = event.currentTarget.dataset.variantId;
    //  console.log("🧩 Button dataset:1", event.currentTarget.dataset);
      fetch(`/products/${handle}?view=quick-add`)
        .then((res) => res.text())
        .then((html) => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, "text/html");
          const modalContent = doc.querySelector(".quick-add-modal");
          
          if (modalContent) {
            // If there is an edit line, assign it to the modal to submit for processing
            if (editLine) {
              /*
              console.log("👉 handle:", handle);
              console.log("👉 editLine:", editLine);
              console.log("👉 variantId:", variantId);
              console.log("Target:", event.target);
              console.log("CurrentTarget:", event.currentTarget);
              console.log("Dataset:", event.currentTarget?.dataset); */
              modalContent.dataset.editLine = editLine;
              modalContent.dataset.variantId = variantId; //attach variant already in cart
            }
            document
              .querySelectorAll(".quick-add-modal")
              .forEach((el) => el.remove());
            document.body.appendChild(modalContent);
            initializeQuickAddModal(modalContent);

            const modal = modalContent.querySelector('[role="dialog"]');
            if (modal) modal.focus();
            modalContent.classList.add("quick-add-modal--open");
            // Close modal when clicking outside
            modalContent.addEventListener("click", (e) => {
              if (e.target === modalContent) {
                //modalContent.remove();
                modalContent.classList.remove("quick-add-modal--open");
                setTimeout(() => modalContent.remove(), 300); // wait for effect to complete
              }
            });
            //Close modal wiht X
            modalContent
              .querySelector(".quick-add-modal__close")
              ?.addEventListener("click", () => {
                //modalContent.remove();
                modalContent.classList.remove("quick-add-modal--open");
                setTimeout(() => modalContent.remove(), 300);
              });
            //Keyboard
            modalContent.setAttribute("tabindex", "-1");
            modalContent.focus();

            const form = modalContent.querySelector("form");
            if (form) {
              form.addEventListener("submit", (e) => {
                e.preventDefault();
                const formData = new FormData(form);
                const variantId = formData.get("id");
               // console.log("🔍 Variant ID submitted:", variantId);
                const modalEl = form.closest(".quick-add-modal");
                if (!modalEl) {
                  console.error("❌ .quick-add-modal not found from form.");
                  return;
                }
                const editLine = modalEl.dataset.editLine;

                if (!variantId) {
                  alert("Product variation could not be determined.");
                  return;
                }
                if (editLine) {
                  // Need to delete old line first (quantity: 0)
                  fetch("/cart/change.js", {
                    method: "POST",
                    headers: {
                      "Content-Type": "application/json",
                      Accept: "application/json",
                    },
                    body: JSON.stringify({
                      line: Number(editLine),
                      quantity: 0,
                    }),
                  })
                    .then((res) => res.json())
                    .then(() => {
                      // After deleting, add new product
                      return fetch("/cart/add.js", {
                        method: "POST",
                        headers: {
                          "Content-Type": "application/json",
                          Accept: "application/json",
                        },
                        body: JSON.stringify({ id: variantId, quantity: 1 }),
                      });
                    })
                    .then((res) => res.json())
                    .then((data) => {
                      modalEl.classList.remove("quick-add-modal--open");
                      setTimeout(() => modalEl.remove(), 300);

                      showCartNotification(data);
                      if (window.shopEnhancer?.updateCartCount) {
                        setTimeout(
                          () => window.shopEnhancer.updateCartCount(),
                          300
                        );
                      }

                      location.reload(); // or update the cart section if it is a drawer
                    })
                    .catch((err) => {
                      console.error("Edit cart failed:", err);
                      alert("Product update failed. Please try again.");
                    });
                } else {
                  // Normal case: add new cart
                  fetch("/cart/add.js", {
                    method: "POST",
                    headers: {
                      "Content-Type": "application/json",
                      Accept: "application/json",
                    },
                    body: JSON.stringify({ id: variantId, quantity: 1 }),
                  })
                    .then((res) => res.json())
                    .then((data) => {
                      //modalContent.remove();
                      modalContent.classList.remove("quick-add-modal--open");
                      setTimeout(() => modalContent.remove(), 300);

                      showCartNotification(data);
                      if (window.shopEnhancer?.updateCartCount) {
                        console.log(
                          "⏱ Waiting 300ms before updating cart count..."
                        );
                        setTimeout(() => {
                          window.shopEnhancer.updateCartCount(); // ✅ Fix: wait for server to update shopping cart
                        }, 300);
                      }
                    })
                    .catch((err) => {
                      console.error("Add to cart failed:", err);
                    });
                }
              });
            }
          }
        });
    });
  });
};
//Call DOMContentLoaded initialization first time
document.addEventListener("DOMContentLoaded", function () {
  if (window.shopEnhancer?.initQuickAddIcons) {
    window.shopEnhancer.initQuickAddIcons(document);
  }
});

// ✅ Show cart notification after adding product
//  Show cart notification with accurate variant image and labeled options
// - Use variant.featured_image for correct thumbnail
// - Use product.options_with_values for labeled attributes like Color, Size
function showCartNotification(item) {
  fetch(`/products/${item.handle}.js`)
    .then((res) => res.json())
    .then((product) => {
      const notification = document.getElementById("cart-notification");
      const notificationProduct = document.getElementById(
        "cart-notification-product"
      );

      const variant = product.variants.find(
        (v) => String(v.id) === String(item.id)
      );
      if (!variant || !notification || !notificationProduct) return;

      const imageUrl = variant.featured_image?.src || product.featured_image;

      // Logical combination: if product.options exists then use label, otherwise fallback
      const optionList = variant.options
        .map((value, i) => {
          const label =
            Array.isArray(product.options) &&
            typeof product.options[i] === "string"
              ? product.options[i]
              : `Option ${i + 1}`;
          return `
            <div class="product-option">
              <dt>${label}:</dt>
              <dd>${value}</dd>
            </div>
          `;
        })
        .join("");

      notificationProduct.innerHTML = `
        <div class="cart-notification-product__image global-media-settings">
          <img src="${imageUrl}" alt="${
        product.title
      }" width="70" height="70" loading="lazy">
        </div>
        <div>
          <h3 class="cart-notification-product__name h4">${product.title}</h3>
          <div class="cart-notification-product__price">$${(
            variant.price / 100
          ).toFixed(2)}</div>
          <dl>${optionList}</dl>
        </div>
      `;

      notification.classList.add("active");
      notification.setAttribute("aria-modal", "true");
      notification.focus();

      function handleOutsideClick(e) {
        if (!e.target.closest(".cart-notification")) {
          notification.classList.remove("active");
          document.removeEventListener("click", handleOutsideClick);
        }
      }

      setTimeout(() => {
        document.addEventListener("click", handleOutsideClick);
      }, 100);

      setTimeout(() => {
        notification.classList.remove("active");
        document.removeEventListener("click", handleOutsideClick);
      }, 10000);
    })
    .catch((err) => {
      console.error("Error loading product:", err);
    });
}

// ✅ Update cart bubble count after adding product
function updateCartCount() {
  fetch("/cart.js")
    .then((res) => res.json())
    .then((cart) => {
      const countBubble = document.querySelector(".cart-count-bubble");
      if (countBubble) {
        countBubble.textContent = cart.item_count;
        countBubble.classList.toggle("hidden", cart.item_count === 0);
      }
    });
}

// ✅ Close notification when clicking the close icon
document
  .querySelector(".cart-notification__close")
  ?.addEventListener("click", () => {
    document.getElementById("cart-notification").classList.remove("active");
  });

// ✅ Initialize modal interactions (image, price, variant switch)
function initializeQuickAddModal(modalElement) {
  const variantSelect = modalElement.querySelector("#variant-select");
  const productImage = modalElement.querySelector(".product-image");
  const thumbnails = modalElement.querySelectorAll(".variant-thumbnail");
  const priceElement = modalElement.querySelector("#variant-price");

  function updateImage(url) {
    if (productImage && url) {
      productImage.src = url;
      productImage.loading = "eager";
    }
  }

/*  function updatePrice(price) {
    if (priceElement && price) {
      priceElement.textContent = price;
    }
  } */
  // add compareAtPrice, %
const priceBlock = document.getElementById('variant-price-block');
if (variantSelect && priceBlock) {
  variantSelect.addEventListener('change', function () {
    const selectedOption = this.options[this.selectedIndex];
    const price = selectedOption.dataset.price;
    const compareAtPrice = selectedOption.dataset.compareAtPrice;

    updatePrice(price, compareAtPrice);
  });

  // Initialize price when modal first opens
  const selectedOption = variantSelect.options[variantSelect.selectedIndex];
  updatePrice(selectedOption.dataset.price, selectedOption.dataset.compareAtPrice);
}

function updatePrice(price, compareAtPrice) {
  const currentPrice = parseFloat(price);
  const originalPrice = parseFloat(compareAtPrice);

  if (isNaN(currentPrice)) {
    priceBlock.innerHTML = `<span class="current-price text-red-500">Price unavailable</span>`;
    return;
  }

  if (!isNaN(originalPrice) && originalPrice > currentPrice) {
    const discountPercent = Math.round(((originalPrice - currentPrice) / originalPrice) * 100);
    priceBlock.innerHTML = `
      <div class="product-price-block">
        <span class="current-price">$${currentPrice.toFixed(2)}</span>
        <span class="product-compare-price"><s>$${originalPrice.toFixed(2)}</s></span>
        <span class="product-discount">-${discountPercent}%</span>
      </div>
    `;
  } else {
    priceBlock.innerHTML = `
      <div class="product-price-block">
        <span class="current-price">$${currentPrice.toFixed(2)}</span>
      </div>
    `;
  }
}


  function updateThumbnailActive(variantId) {
    thumbnails.forEach((thumb) => {
      thumb.classList.toggle("selected", thumb.dataset.variantId === variantId);
    });
  }

  function syncVariantById(variantId) {
    const option = variantSelect.querySelector(`option[value="${variantId}"]`);
    if (!option) return;

    if (variantSelect.value !== variantId) {
      variantSelect.value = variantId;
      variantSelect.dispatchEvent(new Event("change", { bubbles: true }));
    }

    updateImage(option.dataset.image);
   // updatePrice(option.dataset.price);
    updatePrice(option.dataset.price, option.dataset.compareAtPrice);
    updateThumbnailActive(variantId);
  }

  if (!variantSelect) {
    console.warn("⚠️ Not found #variant-select in  modal.");
    return;
  }
  variantSelect?.addEventListener("change", (e) => {
    const selectedId = e.target.value;
    syncVariantById(selectedId);
  });

  thumbnails.forEach((thumb) => {
    thumb.addEventListener("click", () => {
      const variantId = thumb.dataset.variantId;
      syncVariantById(variantId);
    });
  });

  // Initialize with the default selected variant
  if (variantSelect) {
    syncVariantById(variantSelect.value);
  }
}
//
window.shopEnhancer = window.shopEnhancer || {};

window.shopEnhancer.addToCartByHandle = function (handle) {
  fetch(`/products/${handle}?view=quick-add`)
    .then((res) => res.text())
    .then((html) => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, "text/html");
      const modalContent = doc.querySelector("#quick-add-modal-template");
      if (modalContent) {
        const modal = document.querySelector("#quick-add-modal");
        modal.innerHTML = modalContent.innerHTML;
        modal.classList.add("open");

        //Call init again if form needs to be processed
        const form = modal.querySelector('form[action="/cart/add"]');
        if (form) {
          form.addEventListener("submit", (e) => {
            e.preventDefault();
            const formData = new FormData(form);
            fetch("/cart/add.js", {
              method: "POST",
              body: formData,
            }).then(() => {
              window.shopEnhancer.updateCartCount();
              modal.classList.remove("open");
            });
          });
        }
      }
    });
};

// ✅ Dispatch after the entire function has been defined //content_for_layout before .js
window.dispatchEvent(new Event("shopEnhancer:ready")); //Fix collection custom 20250629

/* not used because it puts the icon outside <a>
//Fix Error Silder => <a> , redirect, Recommendations silder
// Always ensure to catch the event for every .add-to-cart_new even after creation
document.addEventListener("click", function (e) {
  const button = e.target.closest(".add-to-cart_new");
  if (!button) return;

  e.preventDefault(); // Prevent default redirect if <a>
  if (button.dataset.bound === "true") return;

  //  Check to avoid double-bind if necessary
  button.dataset.bound = "true";

  // Callback logic already available in initQuickAddIcons
  window.shopEnhancer?.initQuickAddIcons(button.parentNode || document);
  // Trigger event again after successful binding
  button.click();
});

*/
